export default __webpack_public_path__ + "static/media/la_capelle9.5b854f11.jpg";